import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetInflammationGauge() {

  return (

      <GaugeWithNeedle realAge={69} chronologicalAge={62} />
    
  );
};




